import { readingSerif } from '../Landing/fonts';
import { INK } from '../Landing/ui';

// Must-try dishes as a little menu card — same dialect as the Menu
// Translator artifact it sits next to on the page.
export default function DishMenuCard({ mustTryDishes, title }) {
  if (!mustTryDishes || mustTryDishes.length === 0) return null;

  return (
    <div className="tw-mx-auto tw-w-full tw-max-w-[20rem] -tw-rotate-1 tw-rounded-xl tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-p-6 tw-shadow-[0_18px_38px_-26px_rgba(29,45,40,0.5)]">
      <div className="tw-border-0 tw-border-b-[3px] tw-border-double tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-pb-3 tw-text-center">
        <p className="tw-m-0 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.35em] tw-text-primary-700 dark:tw-text-primary-300">
          Menu
        </p>
        <p className="tw-m-0 tw-mt-1 tw-font-mono tw-text-[9px] tw-tracking-[0.22em] tw-text-[#8A958F]">
          {title ? `TASTE OF ${title.toUpperCase()}` : 'THE LOCAL TABLE'}
        </p>
      </div>
      <ul className="tw-m-0 tw-mt-4 tw-list-none tw-p-0">
        {mustTryDishes.map(dish => (
          <li key={dish} className="tw-flex tw-items-baseline tw-gap-2 tw-py-2">
            <span
              className={`${INK} tw-shrink-0 tw-text-[15px] tw-italic`}
              style={{ fontFamily: readingSerif.style.fontFamily }}
            >
              {dish}
            </span>
            <span
              aria-hidden="true"
              className="tw-mx-1 tw-min-w-4 tw-flex-1 tw-border-0 tw-border-b tw-border-dotted tw-border-[#C9C0AA] dark:tw-border-[#3A4D44]"
            />
            <span className="tw-shrink-0 tw-font-mono tw-text-[8px] tw-font-semibold tw-tracking-[0.2em] tw-text-primary-700 dark:tw-text-primary-300">
              MUST TRY
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
